import React, { useState } from 'react'
import PropTypes from 'prop-types'
import FormAndCalloutBox from '../../3_Organisms/FormAndCalloutBox/FormAndCalloutBox'
import parse from 'html-react-parser';
import Input from '../../1_Atoms/Forms/Input/Input';
import Button from '../../1_Atoms/Button/Button';
import FormGroup from '../../2_Molecules/FormGroup/FormGroup';
import { handleRequest } from '../../../utils/httpRequest';
import Form from '../../2_Molecules/Form/Form';
import { languageController } from '../../../controllers/language/languageController';
import { useForm } from '../../../hooks/useForm';
import Textarea from '../../1_Atoms/Forms/Textarea/Textarea';
import Checkbox from '../../1_Atoms/Forms/Checkbox/Checkbox';
import { formatDate } from '../../../utils/helpers';
import CalloutBoxFull from '../../2_Molecules/CalloutBox/CalloutBoxFull';

function ContactDetailsStep({
  handleNextStep,
  title,
  submitButtonText,
  dealerData,
  dateAndTimeData,
  vehicleData,
  formSource,
  formPid,
  formEndPointUrl,
  formLanguage,
}) {
  const [formError, setFormError] = useState(null)

  const { dealer: selectedDealerData, userPosition } = dealerData || {};

  const initState = {
    firstname: '',
    lastname: '',
    email: '',
    postalcode: '',
    message: '',
    optin: 'off', // 'on' or 'off'
  }

  const validations = {
    firstname: ['required', 'name', 'nameMaxMin'],
    lastname: ['required', 'name', 'nameMaxMin'],
    email: ['required', 'email'],
    postalcode: ['required', 'postalcode'],
  }

  const { handleSubmit, handleChange, data: formData, errors, setData } = useForm({
    initState,
    validations,
    // Send the form data if validated
    onSubmit: async () => {
      try {
        const otherData = {
          source: formSource,
          language: formLanguage,
          pid: String(formPid)
        }

        // Add selectedDealerData data if passed
        if (selectedDealerData) {
          otherData.dealerid = selectedDealerData.dealer_code
        }

        // Add vehicleData data if passed
        if (vehicleData) {
          otherData.year = vehicleData.year;
          otherData.model = vehicleData.model;
        }

        // Add Date and Time data if passed
        if (dateAndTimeData) {
          otherData.date = formatDate(dateAndTimeData.date)
          otherData.time = dateAndTimeData.time
        }

        const res = await handleRequest('post', formEndPointUrl, { ...formData, ...otherData });

        if (res.Success) {
          handleNextStep({ contactDetails: formData })
        } else {
          setFormError(res.state ? res.state : res.Errors[0])
        }
      } catch (err) {
        console.log(err)
      }
    },
  })

  const { firstname, lastname, email, postalcode, message, optin } = formData;

  const isFormFilled = (firstname && lastname && email && postalcode)

  return (
    <div className="mz-contact-details-step">
      <div className="mz-contact-details-step__top">
        <div className="mz-container">
          <div className="mz-full-width">
            <h5 className="mz-contact-details-step__title">{title}</h5>
          </div>
        </div>
      </div>
      <FormAndCalloutBox>
        <FormAndCalloutBox.Form>
          <Form
            type="contact-details"
            onSubmit={handleSubmit}
            isDark={false}
            noValidate={true}
            requiredFieldsHelperText={true}
            errorMessage={formError}
          >
            <FormGroup md={2}>
              <Input
                type="text"
                name="firstname"
                label={languageController.getFormCopy('label', 'firstname')}
                value={firstname}
                isRequired={true}
                errorMessage={errors.firstname}
                onChange={handleChange}
                maxLength={50}
              />
              <Input
                type="text"
                name="lastname"
                label={languageController.getFormCopy('label', 'lastname')}
                value={lastname}
                isRequired={true}
                errorMessage={errors.lastname}
                onChange={handleChange}
                maxLength={50}
              />
            </FormGroup>
            <Input
              type="email"
              name="email"
              label={languageController.getFormCopy('label', 'email')}
              value={email}
              isRequired={true}
              errorMessage={errors.email}
              onChange={handleChange}
              maxLength={320}
            />
            <FormGroup md={2}>
              <Input
                type="text"
                name="postalcode"
                label={languageController.getFormCopy('label', 'postalcode')}
                value={postalcode}
                isRequired={true}
                errorMessage={errors.postalcode}
                onChange={handleChange}
                maxLength={7}
              />
            </FormGroup>
            <Textarea
              name="message"
              label={languageController.getFormCopy('label', 'message2500')}
              value={message}
              errorMessage={errors.message}
              onChange={handleChange}
              maxLength={2500}
              rows={5}
            />
            <Checkbox
              name="optin"
              checked={(optin === 'on')}
              onChange={(e) => setData({ ...formData, optin: optin === 'off' ? 'on' : 'off' })}
              label={parse(languageController.getCopy('global', 'subscribeLegal'))}
            />
            <Button
              type="submit"
              className="mz-btn--primary mz-btn--red"
              label={submitButtonText}
              disabled={!isFormFilled}
            />
          </Form>
        </FormAndCalloutBox.Form>
        <FormAndCalloutBox.Callout>
          <CalloutBoxFull
            vehicleData={vehicleData}
            dealerData={selectedDealerData}
            userPosition={userPosition}
            dateAndTimeData={dateAndTimeData}
          />
        </FormAndCalloutBox.Callout>
      </FormAndCalloutBox>
    </div>
  )
}

ContactDetailsStep.propTypes = {
  handleNextStep: PropTypes.func.isRequired,
  title: PropTypes.string,
  submitButtonText: PropTypes.string,
  dealerData: PropTypes.object,
  dateAndTimeData: PropTypes.object,
  vehicleData: PropTypes.object,
  formSource: PropTypes.string.isRequired,
  formPid: PropTypes.number.isRequired,
  formEndPointUrl: PropTypes.string.isRequired,
  formLanguage: PropTypes.string.isRequired,
}

ContactDetailsStep.defaultProps = {
  submitButtonText: '',
  dealerData: null,
  dateAndTimeData: null,
  vehicleData: null,
}

export default ContactDetailsStep